import React from 'react';
import { usePortfolioLens, PortfolioLens } from '../../contexts/PortfolioLensContext';

interface PortfolioLensToggleProps {
  className?: string;
}

/**
 * All / CC / CSP segmented control for the portfolio pages. Uses the shared
 * trader-theme `.seg` control (screener-trader.css), like StrategyToggle, but is backed by the portfolio-scoped lens
 * (PortfolioLensContext), which is independent of the screener's strategy.
 */
const PortfolioLensToggle: React.FC<PortfolioLensToggleProps> = ({ className }) => {
  const { lens, setLens } = usePortfolioLens();

  const options: { value: PortfolioLens; label: string; shortLabel: string }[] = [
    { value: 'all', label: 'All', shortLabel: 'All' },
    { value: 'cc', label: 'Covered Calls', shortLabel: 'CC' },
    { value: 'csp', label: 'Cash Secured Puts', shortLabel: 'CSP' },
  ];

  return (
    <div className={`seg portfolio-lens-toggle ${className || ''}`} role="group" aria-label="Strategy lens">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => setLens(opt.value)}
          aria-pressed={lens === opt.value}
          title={opt.label}
        >
          <span className="strategy-toggle-full">{opt.label}</span>
          <span className="strategy-toggle-short">{opt.shortLabel}</span>
        </button>
      ))}
    </div>
  );
};

export default PortfolioLensToggle;
